"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'googleDrive.picker.title': 'Seleccionar archivo de Google Drive',
    'googleDrive.picker.selectFile': 'Seleccionar archivo de Google Drive',
    'googleDrive.picker.selectFiles': 'Seleccionar archivos de Google Drive',
    'googleDrive.picker.loading': 'Cargando API de Google Drive...',
    'googleDrive.picker.initializing': 'Inicializando selector de archivos...',
    'googleDrive.picker.notAuthenticated': 'Google Drive no conectado',
    'googleDrive.picker.statusError': 'Error al verificar el estado de Google Drive',
    'googleDrive.picker.filesLoadError': 'Error al cargar archivos',
    'googleDrive.picker.checkingAuth': 'Verificando autenticación...',
    'googleDrive.picker.authRequired': 'Por favor conecte su cuenta de Google Drive primero',
    'googleDrive.picker.connectAccount': 'Conectar Google Drive',
    'googleDrive.picker.loadingFiles': 'Cargando sus archivos de Google Drive...',
    'googleDrive.picker.noFiles': 'No se encontraron archivos',
    'googleDrive.picker.noFilesDesc': 'Su Google Drive parece estar vacío',
    'googleDrive.picker.refresh': 'Actualizar',
    'googleDrive.picker.searchPlaceholder': 'Buscar archivos...',
    'googleDrive.picker.filesFound': 'archivos encontrados',
    'googleDrive.picker.initError': 'Error al inicializar el selector de Google Drive',
    'googleDrive.picker.loadingError': 'Error al cargar las APIs de Google Drive',
    'googleDrive.picker.noAccessToken': 'Token de acceso no disponible',
    'googleDrive.picker.error': 'Error del selector de Google Drive',
    'googleDrive.picker.fileSelected': 'Archivo seleccionado',
    'googleDrive.picker.filesSelected': 'archivos seleccionados',
    'googleDrive.picker.authError': 'Error de autenticación de Google',
    'googleDrive.picker.configError': 'Error de configuración de Google',
    'googleDrive.picker.connectFirst': 'Por favor conecte Google Drive en configuración primero',
    'googleDrive.picker.selectDirectory': 'Seleccionar directorio de Google Drive',
    'googleDrive.picker.createError': 'Error al abrir el selector de Google Drive',
    'googleDrive.picker.tokenExpired': 'El acceso a Google Drive ha expirado. Por favor, vuelva a conectar su cuenta de Google Drive en la configuración.',
    'googleDrive.picker.refreshFailed': 'Error al actualizar el acceso a Google Drive. Por favor, vuelva a conectar su cuenta en la configuración.',
};
